var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M5 15L14.9996 5","stroke":"white","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M5 5L14.9996 15","stroke":"white","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Close.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Close;

Close.default = Close;
